import React, { useContext } from 'react';
import ThemeButton from './ThemeButton';
import { ThemeContext } from '../Theme';
import { makeFirstLetterCapital } from '../utils/heplers';

export default function ThemeSwitcher() {
  const { theme, themeType, setThemeTypeHandler, toggleTheme } =
    useContext(ThemeContext);
  const getThemeName = () =>
    `${
      themeType === 'default'
        ? theme === 'dark'
          ? 'Monkeytype'
          : 'Solarize'
        : makeFirstLetterCapital(themeType)
    } ${makeFirstLetterCapital(theme)}`;

  return (
    <div className='theme-controls'>
      <span className='theme-label-compact'>
        <strong>Theme - </strong>
        {getThemeName()}
      </span>
      <label className='theme-toggle'>
        <input
          type='checkbox'
          className='theme-slider'
          checked={theme === 'dark'}
          onChange={toggleTheme}
        />
        <span className='slider custom' />
      </label>
      <div className='theme-btn-list-compact'>
        {theme === 'dark' ? (
          <>
            <ThemeButton
              theme='monkey'
              selected={themeType === 'default'}
              onClick={() => setThemeTypeHandler('default')}
            />
            <ThemeButton
              theme='dracula'
              selected={themeType === 'dracula'}
              onClick={() => setThemeTypeHandler('dracula')}
            />
            <ThemeButton
              theme='synth-wave'
              selected={themeType === 'synth-wave'}
              onClick={() => setThemeTypeHandler('synth-wave')}
            />
          </>
        ) : (
          <>
            <ThemeButton
              theme='solarize'
              selected={themeType === 'default'}
              onClick={() => setThemeTypeHandler('default')}
            />
            <ThemeButton
              theme='horizon'
              selected={themeType === 'horizon'}
              onClick={() => setThemeTypeHandler('horizon')}
            />
            <ThemeButton
              theme='tomorrow'
              selected={themeType === 'tomorrow'}
              onClick={() => setThemeTypeHandler('tomorrow')}
            />
          </>
        )}
      </div>
    </div>
  );
}
